//File Generated by Castle.
//!IMPORTANT Manual Changes to this file will be overwritten

import React from "react";
import { ButtonBase } from "@mui/material";

export default function PrimaryButton({ onClick, value, children, ...props }) {
  const label = children;
  return (
    <ButtonBase
      {...props}
      sx={{
        color: "rgba(0,0,0,0.87)",
        backgroundColor: "#FFF",
        opacity: 0.8,
        borderTopLeftRadius: 18,
        borderTopRightRadius: 18,
        borderBottomRightRadius: 18,
        borderBottomLeftRadius: 18,
        minHeight: 48,
        "&.Mui-disabled": {
          color: "rgb(102, 102, 102, .2)",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        },
        "&:hover, &.Mui-focusVisible": {
          zIndex: 1,
          opacity: 1,
          transition: "opacity 0.3s ease-out 0.1s",
        },
      }}
      onClick={onClick}
    >
      {label}
    </ButtonBase>
  );
}
